module.exports = __webpack_public_path__ + "static/media/supernova.65f508f8.jpg";